import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PageLoading } from './components/loading/PageLoading/PageLoading';
import { CustomDefaultBackdrop } from './components/backdrop/default/v1/components/CustomDefaultBackdrop';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import RootPage from './pages/root';
import { SmartstorePage } from './pages/smartstore';
import { ApiInfoContextProvider } from './contexts/ApiInfoContext';
import { CoupangPage } from './pages/coupang';
import { ReturnExchangePage } from './pages/return-exchange';
import { ReturnExchange_SearchPage } from './pages/return-exchange/search';
import { ReturnExchange_ArchivePage } from './pages/return-exchange/archive';
import { ReturnExchange_DownloadFormPage } from './pages/return-exchange/download-form';
import { ReturnExchange_RegisterPage } from './pages/return-exchange/register';
import { StockCyclePage } from './pages/stock-cycle';

function App() {
	return (
		<>
			<ApiInfoContextProvider>
				<HelmetProvider>
					<CustomDefaultBackdrop />

					<BrowserRouter>
						<AppCore />
					</BrowserRouter>
				</HelmetProvider>
			</ApiInfoContextProvider>
		</>
	);
}

function AppCore() {
	return (
		<>
			<Helmet>
				<title>피아르 셀러툴</title>
				{/* <meta name="description" content="무료 멀티링크 연결 서비스. 인스타, 유튜브, 쇼핑몰, 포트폴리오 등 다양한 링크를 정리하고 싶을때, 프로필링크를 사용해보세요." />
				<meta name="keywords" content="인스타프로필링크, 멀티링크, 인스타그램프로필링크, 유튜브프로필링크, 틱톡프로필링크, 트위터프로필링크, 카카오톡프로필링크" />
				<meta property="og:type" content="website" />
				<meta property="og:title" content="슈룩 - 멀티 프로필링크" />
				<meta property="og:description" content="무료 멀티링크 연결 서비스. 인스타, 유튜브, 쇼핑몰, 포트폴리오 등 다양한 링크를 정리하고 싶을때, 프로필링크를 사용해보세요." />
				<meta property="og:url" content="https://shool.uk" />
				<meta property="og:image" content="https://shool.uk/assets/images/shooluk_logo.png" />
				<meta property="og:image:secure_url" content="https://shool.uk/assets/images/shooluk_logo.png" />
				<meta property="og:site_name" content="슈룩 - 멀티 프로필링크" /> */}
			</Helmet>
			<Routes>
				<Route path='/' element={<RootPage />} />
				<Route path='/smartstore' element={<SmartstorePage />} />
				<Route path='/coupang' element={<CoupangPage />} />
				<Route path='/return-exchange' element={<ReturnExchangePage />} />
				<Route path='/return-exchange/register' element={<ReturnExchange_RegisterPage />} />
				<Route path='/return-exchange/search' element={<ReturnExchange_SearchPage />} />
				<Route path='/return-exchange/archive' element={<ReturnExchange_ArchivePage />} />
				<Route path='/return-exchange/download-form' element={<ReturnExchange_DownloadFormPage />} />
				<Route path='/stock-cycle' element={<StockCyclePage />} />
			</Routes>
		</>
	)
}

export default App;
